import React from "react";

import Images from "../ALL_Images/Images.js";

import { Link, useLocation } from "react-router-dom";
import PackageModal from "./package_modal/PackageModal";
import "bootstrap/dist/css/bootstrap.min.css";
import "../plugins/navbar";

import "../css/Navbar.css";
import Temp from "./Temp";
import { connect } from "react-redux";
import { useState, useEffect } from "react";

const NavBar = (props) => {
  const [menu, setMenu] = useState(false);
  const [showPackageModal, setShowPackageModal] = useState(false);
  const [loginlink, setLoginlink] = useState(
    JSON.parse(localStorage.getItem("auth"))
  );

  const location = useLocation();

  useEffect(() => {
    setLoginlink(JSON.parse(localStorage.getItem("auth")));
  }, [location]);

  // console.log(loginlink);

  // this.toggleMenu = this.toggleMenu.bind(this);
  // this.collapsMenu = this.collapsMenu.bind(this);
  // this.setDisplayModal = this.setDisplayModal(this);

  function toggleMenu() {
    // this.setState({ menu: !this.state.menu });
    setMenu(!menu);
  }

  function setDisplayModal() {
    setShowPackageModal(false);
  }

  function collapsMenu() {
    // this.setState({ menu: false });
    setMenu(false);
  }

  function bookAShootHandler() {
    props.bookAShoot();
  }

  const show = menu ? "show" : "";
  return (
    <>
      {showPackageModal ? (
        <PackageModal setDisplayModal={setDisplayModal} />
      ) : null}
      <nav
        className="navbar navbar-expand-lg navbar-light bg-light"
        id="navbar"
      >
        <Link onClick={collapsMenu} className="navbar-brand" to="/">
          {" "}
          <img
            src={Images.fodrixiconnew}
            className="image"
            width="130px"
            height="71px"
            alt="Fodrix Logo"
            style={{ height: "57px", width: "100px" }}
          />{" "}
        </Link>{" "}
        <button className="navbar-toggler" type="button" onClick={toggleMenu}>
          <span className="navbar-toggler-icon"> </span>{" "}
        </button>{" "}
        <div id="collapse" className={"collapse navbar-collapse " + show}>
          <div id="right" className="navbar-nav bg-light">
            <Link
              onClick={collapsMenu}
              className="nav-item nav-link"
              to="/photoshoot_services"
            >
              Services
            </Link>{" "}
            <Link
              onClick={collapsMenu}
              className="nav-item nav-link"
              to="/packages"
            >
              {" "}
              Packages{" "}
            </Link>{" "}
            <Link
              onClick={collapsMenu}
              className="nav-item nav-link"
              to="/HowItWorks"
            >
              {" "}
              How it Works{" "}
            </Link>{" "}
            <Link
              onClick={collapsMenu}
              className="nav-item nav-link"
              to="/about_us"
            >
              {" "}
              AboutUs{" "}
            </Link>{" "}
            <Link
              onClick={collapsMenu}
              id="logout"
              className="nav-item nav-link"
              to={loginlink ? "/dashboard" : "/login"}
            >
              {loginlink ? "Dashboard" : "Login"}
            </Link>
            <a
              onClick={collapsMenu}
              className="nav-item nav-link"
              href="tel:07020147576"
            >
              {" "}
              <i className="fas fa-phone-alt"></i>&nbsp;07020147576{" "}
            </a>
            {/* <Link onClick={this.collapsMenu} className="nav-item nav-link" to="/userdashboard"> */}{" "}
            <Link to="/userdashboard">
              <button
                className="btn btn-primary"
                onClick={() => {
                  // this.bookAShootHandler.bind(this);
                  setShowPackageModal(true);
                }}
              >
                {" "}
                Book A Shoot <i className="fas fa-hand-point-up"> </i>{" "}
              </button>
            </Link>{" "}
            {/* </Link> */}
          </div>{" "}
        </div>{" "}
      </nav>

      <Temp />
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    bookAShoot: () => dispatch({ type: "bookAShoot" }),
  };
};

export default connect(null, mapDispatchToProps)(NavBar);
